<template>
  <div class="page " style="min-height: 100vh;">
    <div class="container  inner-page">
      <div class="app-header">
        <router-link :to="{ name: 'Home' }"><img class="app-logo" src="../assets/logo2.png"/></router-link>
        <!--
        <div class=" btn lgLink">

        <a @click="changeLG">{{ $t('home.languageSwitch') }}</a>
        </div>-->
      </div>
      <div style="" :class="{ flowLayout: isFlowLayout }">
        <h1 class="title" v-if="$t('themes.title')" style=" margin-bottom: 1rem;">{{ $t('themes.title') }}</h1>
        <div v-if="$t('themes.text')" style=" margin-bottom: 1rem; text-align:left" v-html="$t('themes.text')"></div>
        <div v-if="categories">
          <div v-for="cat in categories" :key="cat.id" class="cat">
            <div class="catTitle" v-if="cat.name">{{ cat.name }}</div>
            <ThemeSelection
              v-on:themeSelected="onThemeSelected"
              v-on:promoSelected="onPromoSelected"
              :layouts="cat.layouts"
              :displayPromo="cat.displayPromo || false"
            >
            </ThemeSelection>
          </div>
        </div>
      </div>
      <Footer ref="footer"></Footer>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies

import ThemeSelection from '../components/ThemeSelector.vue';
import store from '../store';

export default {
  name: 'Theme',

  components: {
    ThemeSelection,
  },
  directives: {},

  data() {
    return {};
  },

  computed: {
    categories() {
      return this.$store.eventConfig && this.$store.eventConfig.categories;
    },

    isFlowLayout() {
      return this.$store.largeScreenLayout;
    },
  },

  methods: {
    onThemeSelected(layoutId) {
      this.$router.push({ name: 'Theme', params: { id: layoutId } });
    },

    onPromoSelected() {
      this.$refs.footer.displayContact();
    },

    changeLG(e) {
      e.preventDefault();
      e.stopPropagation();

      const lg = this.$i18n.t('home.languageSwitchLocale');
      // console.log('Switch language', lg);
      // eslint-disable-next-line no-undef
      this.$i18n.locale = lg;
    },
  },
  beforeRouteEnter(to, from, next) {
    // in this case

    if (store.eventConfig && store.eventConfig.onlyOneLayout) {
      next({ name: 'Theme', params: { id: store.eventConfig.onlyOneLayout } });
      return;
    }

    next(true);
  },

  mounted() {},
};
</script>

<style scoped>
.catTitle {
  text-align: left;
  font-weight: bold;
  font-size: 1.2em;
  margin: 0.8em 0;
}

.flowLayout .catTitle {
  text-align: center;
}

.cat {
  padding-bottom: 1.4em;
}
</style>
